// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".top-level .col>.labeled-select[data-v-8fcdd476]:not(.taggable){max-height:100%;height:100%}.info-box[data-v-8fcdd476]{flex-grow:0}", ""]);
// Exports
module.exports = exports;
